import Vue from 'vue'
import Vuex from 'vuex'
import addEmployee from './modules/addEmployee'
import addPage from './modules/addPage'
import ourService from './modules/ourService'
import carusel from './modules/carousel'
import faq from './modules/faq'
import fotos from './modules/fotos'
import interactive from './modules/interactive'
import login from './modules/login'
import menu from './modules/menu'
import numbers from './modules/dialog'
import news from './modules/news'
import newsImages from './modules/newsImage'
import pagesImages from './modules/pagesImage'
import rahbariyat from './modules/rahbariyat'
import usefulLink from './modules/usefulLink'
import kurslar from './modules/kurslar'
import tadbirlar from './modules/tadbirlar'
import video from './modules/video'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { login, video, menu, numbers, news, newsImages, carusel, rahbariyat,  addPage, addEmployee, fotos, pagesImages, ourService, faq, usefulLink, interactive, kurslar, tadbirlar },
  strict: true

})
